
import ChooseDeliveryLocation from "../delivery-address/choose-delivery-location.vue";
import ResponsiveDialog from "./responsive-dialog.vue";
export default {
  components: { ResponsiveDialog, ChooseDeliveryLocation },
  props: {
    dialog: false,
    persistent: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isFullscreen: false
    };
  }
};
